import { useMemoizedFn, useRequest } from 'ahooks';
import { useEffect, useMemo } from 'react';
import { getListService, getOverviewService } from '../service.js';
import { hooks } from '@/store.js';
import type { IListItem } from '../interface.js';
import { planDetailEvent } from '../utils/event.js';

const usePlanList = ({
  date,
  id,
  onLoaded,
  onAddOpen,
  showEditCustom,
}: {
  date: string;
  id: string;
  onLoaded: (res: IListItem[] | undefined) => void;
  // 待去除
  onAddOpen?:
    | ((payload?: {
        isAppend?: boolean;
        item: { props: { date: string } };
      }) => void)
    | undefined;
  showEditCustom?: (payload: { id: string }) => void;
}) => {
  const client = hooks.useClient();

  const { data: listData, refresh: refreshList } = useRequest(
    async () => {
      if (!id) return undefined;
      const res = await getListService({
        id,
        client,
      });

      return res;
    },
    {
      cacheKey: `planDetail-${id}`,
      refreshOnWindowFocus: true,
      refreshDeps: [id],
      onSuccess: onLoaded,
    }
  );

  const { data: overviewData, refresh: overviewRefresh } = useRequest(
    async () => {
      const res = await getOverviewService({
        id,
        client,
      });

      return res;
    },
    {
      cacheKey: `planDetail-overview-${id}`,
      refreshOnWindowFocus: true,
      refreshDeps: [id],
    }
  );

  const list = useMemo(() => {
    return (date === '总览' ? overviewData : listData)?.map((i) => {
      if (i.type === 'DayTitle') {
        i.props.onAddOpen = (payload) => onAddOpen?.({ ...payload, item: i });
      } else if (i.type === 'Custom') {
        i.props.onClick = showEditCustom;
      }
      return i;
    });
  }, [listData, date, overviewData]);

  const requestRefresh = useMemoizedFn(() => {
    refreshList();
    overviewRefresh();
  });

  useEffect(() => {
    planDetailEvent.on('requestRefresh', requestRefresh);
    return () => {
      planDetailEvent.off('requestRefresh', requestRefresh);
    };
  }, []);

  return {
    list,
  };
};

export default usePlanList;
